import { useContext, useEffect } from "react";
import { ShareContext } from "../../context/ShareContext";
import { LegalCounselPostJudgement } from "./LegalCounselPostJudgement";
import { AcrPostJudgement } from "./AcrPostJudgement";
import JudgePostJudgement from "./JudgePostJudgement";
import DeputySheriffPostJudgement from "./DeputySheriffPostJudgement";
import ChiefJudgePostJudgement from "./ChiefJudgePostJudgement";

export const PostJudgement = () => {
  const { profile } = useContext(ShareContext);
  useEffect(() => {
    console.log(profile?.role.id);
  }, [profile]);
  const renderContent = () => {
    switch (profile?.role?.id) {
      case 1:
        return <LegalCounselPostJudgement />;
      case 3:
        return <JudgePostJudgement />;
      case 10:
        return <AcrPostJudgement />;
      case 18:
        return <DeputySheriffPostJudgement />;
      case 24:
        return <ChiefJudgePostJudgement />;

      default:
        return <div></div>;
    }
  };

  return (
    <div>
      {/* filter and search goes here */}
      {/* table goes here using the renderContent function */}
      {renderContent()}
    </div>
  );
};
